import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

import css from './TextInput.module.scss';

export enum TextInputType {
  Email = 'email',
  Number = 'number',
  Password = 'password',
  Tel = 'tel',
  Text = 'text',
  TextArea = 'textarea',
}

interface Props {
  name?: string;
  className?: string;
  cols?: number;
  rows?: number;
  type?: TextInputType;
  onChange?: (e: React.ChangeEvent) => void;
  setValue?: boolean;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
}

const TextInput: React.FC<Props> = ({
  className,
  cols,
  rows,
  type,
  onChange,
  setValue,
  ...attr
}) => {
  const textarea = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textareaCurrent = textarea.current;
    if (!textareaCurrent) {
      return;
    }

    if (textareaCurrent.scrollHeight > textareaCurrent.offsetHeight) {
      textareaCurrent.style.height = textareaCurrent.scrollHeight + 'px';
    }
  }, []);

  const classes = classNames(
    css.TextInput,
    { [css.isSetValue]: setValue },
    className,
  );
  const inputType = type || TextInputType.Text;

  switch (inputType) {
    case TextInputType.TextArea:
      return (
        <textarea
          {...attr}
          className={classes}
          cols={cols}
          rows={rows}
          onChange={onChange}
          ref={textarea}
        />
      );
    default:
      return (
        <input
          {...attr}
          className={classes}
          type={inputType}
          onChange={onChange}
        />
      );
  }
};

export default TextInput;
